import React from 'react';
import styled from 'styled-components';
import { Button } from '../ButtonElements';
import logo from '../../assets/Ralph_logo.png';
import { InfoContainer, InfoWrapper, InfoRow, Column1, Column2, TextWrapper, TopLine, Heading, Subtitle, BtnWrap, Img, ImgWrap } from './InfoElements';

const OutlineButton = styled(Button)`
  background: transparent !important;
  color: #1976d3 !important;
  border: 2px solid #1976d3 !important;

  &:hover {
    background: #1976d3 !important;
    color: #fff !important;
    border: 2px solid #1976d3 !important;
  }
`;

const InfoSection = ({ lightBg, id, imgStart, topLine, lightText, headline, darkText, description, description1, description2, buttonLabel, img, alt, primary, dark, dark2, showDownloadButton, onDownloadClick }) => {
  return (
    <>
      <InfoContainer lightBg={lightBg} id={id}>
        <InfoWrapper>
          <InfoRow imgStart={imgStart}>
            <Column1>
              <TextWrapper>
                <TopLine>{topLine}</TopLine>
                <Heading lightText={lightText}>{headline}</Heading>
                <Subtitle darkText={darkText}>{description}</Subtitle>
                <Subtitle darkText={darkText}>{description1}</Subtitle>
                <Subtitle darkText={darkText}>{description2}</Subtitle>
              </TextWrapper>

              <BtnWrap style={{ gap: '15px', flexWrap: 'wrap', marginTop: '20px' }}>
                <Button to='home' smooth={true} duration={500} spy={true} exact='true' offset={-80} primary={primary ? 1 : 0} dark={dark ? 1 : 0} dark2={dark2 ? 1 : 0}>{buttonLabel}</Button>

                {showDownloadButton && (
                  <OutlineButton
                    as="button"
                    onClick={onDownloadClick}
                    primary={0}
                    dark={dark ? 1 : 0}
                  >
                    Download our App here
                  </OutlineButton>
                )}
              </BtnWrap>
            </Column1>
            <Column2>
              <ImgWrap>
                <Img src={logo} alt={alt} />
              </ImgWrap>
            </Column2>

          </InfoRow>
        </InfoWrapper>
      </InfoContainer>
    </>
  );
};

export default InfoSection;
